import { functionalCurrencyOption } from '../constants';
import { ScenarioSharedReduxState } from '../types';


const initialState: ScenarioSharedReduxState = {
  scenarios: [],
  isLoadingScenarios: false,

  scenarioMembers: [],
  isLoadingScenarioMembers: false,

  scenarioAllowedPeriods: [],
  isLoadingScenarioAllowedPeriods: false,

  selectedScenarioToCompare: null,
  selectedView: null,
  selectedEditCY: null,
  selectedCurrency: functionalCurrencyOption.value,

  isLoadingCalculatingScenario: false,

  reportFields: [],
  isLoadingReportFields: false,

  isLoadingUploadTaggedData: false,
  uploadTaggedDataErrors: [],
};

export default initialState;
